import React, { useState } from 'react';
import { X, Plus, RefreshCw } from 'lucide-react';

const AddCompanyModal = ({ theme, styles, onAdd, onClose }) => {
  const [newCompanyName, setNewCompanyName] = useState('');
  const [adding, setAdding] = useState(false);

  const handleAdd = async () => {
    setAdding(true);
    const success = await onAdd(newCompanyName);
    setAdding(false);
    if (success) {
      setNewCompanyName('');
      onClose();
    }
  };

  return (
    <div style={styles.modal} onClick={onClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>Add New Company</h3>
          <button style={styles.closeButton} onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div>
          <label style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: theme === "light" ? "#374151" : "rgba(255, 255, 255, 0.9)",
            marginBottom: "8px",
          }}>
            Company Name
          </label>
          <input
            type="text"
            value={newCompanyName}
            onChange={(e) => setNewCompanyName(e.target.value)}
            placeholder="Enter company name..."
            style={styles.input}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && !adding) handleAdd();
            }}
          />
        </div>

        <div style={styles.modalButtons}>
          <button style={styles.cancelButton} onClick={onClose} disabled={adding}>
            Cancel
          </button>
          <button style={styles.submitButton} onClick={handleAdd} disabled={adding}>
            {adding ? (
              <>
                <RefreshCw size={16} style={{ animation: 'spin 1s linear infinite' }} />
                Creating...
              </>
            ) : (
              <>
                <Plus size={16} />
                Create Company
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddCompanyModal;